import {inject, Injectable} from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  public snackbar = inject(MatSnackBar);
  constructor() { }

  showMessageSuccess(message: string, duration: number = 1500): void {
    this.showSnackbarMessage(message, duration, 'custom-snackbar__success');
  }

  showMessageError(message: string, duration: number = 1500): void {
    this.showSnackbarMessage(message, duration, 'custom-snackbar__error');
  }

  private showSnackbarMessage(message: string, duration: number, panelClass: string): void {
    this.snackbar.open(message, 'x', {
      horizontalPosition: 'right',
      verticalPosition: 'top',
      duration,
      panelClass: panelClass
    });
  }
}
